// Path: middleware/set-page-header.ts
// Adjusted middleware for Nuxt 3 to add a custom header with the page name

import { defineNuxtRouteMiddleware } from 'nuxt/app'
import { logger } from '../utility/logger'

export default defineNuxtRouteMiddleware((to) => {
  // Only run on server-side
  if (process.server) {
    const event = useRequestEvent()
    if (!event) {
      return
    }
    // Use the route name or path as the header value
    const pageName = to.name?.toString() || to.path || 'unknown'
    // Set custom header using H3's setHeader
    event.node.res.setHeader('X-Page-Name', pageName)
  }
})
